var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader",class:{'loader-content': _vm.isContent, 'bg-transparent': _vm.isBgTransparent}},[_c('img',{staticClass:"loader__img",attrs:{"src":require('../assets/images/loader-img.webp'),"width":"115","height":"115"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }